module.exports = __webpack_public_path__ + "img/3.0f04a7bc.png";